// removed by extract-text-webpack-plugin
module.exports = {"guide":"_2iIk","right":"_15Dj","left":"_I0Q","messageArea":"_1Zhm","qr":"_111n","up":"_2fH-","down":"_1Pbk","space":"_3qj_","bubble":"_2Tyk","bubbleIn":"_2JuS","bubbleIcon":"_18uS","bounce":"_3Sjs","bubbleText":"_1nMX","floatAway":"Igdz","floatUp":"Du5U","defaultBubble":"_1jxo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/guide/index.less
// module id = 313
// module chunks = 0